enum SubscriptionPlan {
  INDUSTRY_LEADER = "industryLeader",
  ENTERPRISE = "enterprise",
  FIELD_INTELLIGENCE = "fieldIntelligence",
}

// Cheapest first. Band rank comes from this order, so a band at or below the org's own
// position is never offered.
export const SUBSCRIPTION_PLAN_ORDER = [
  SubscriptionPlan.INDUSTRY_LEADER,
  SubscriptionPlan.ENTERPRISE,
  SubscriptionPlan.FIELD_INTELLIGENCE,
] as const;

// Lowercase fragment matched against the plan name coming from the backend.
export const subscriptionPlanNameFragment: Readonly<Record<SubscriptionPlan, string>> = {
  [SubscriptionPlan.ENTERPRISE]: "enterprise",
  [SubscriptionPlan.FIELD_INTELLIGENCE]: "field intelligence",
  [SubscriptionPlan.INDUSTRY_LEADER]: "industry leader",
};

export default SubscriptionPlan;
